/**
 * Turns a raw backoffice gateway `Error` message into a user-facing one by
 * stripping internal/technical noise that is meaningless to a Nova/Junifer user:
 *  - the leading exception-class prefix, e.g. `"InvalidArgumentGrpcException: "`
 *  - a trailing internal id reference, e.g. `" (id 6313475)"`
 *
 * Returns `''` for null/undefined/empty so callers can apply their own fallback.
 * Reusable across migrated mutations/services that surface the gateway Error union.
 */
export const formatBackofficeErrorMessage = (
  message: string | null | undefined,
): string => {
  if (!message) return ""
  return message
    .replace(/^[A-Za-z]+Exception: /, "")
    .replace(/\(id \d+\)$/, "")
    .trim()
}
